import { useRef } from "react";

export default function useScrollTabs() {
  const scrollRef = useRef(null);

  const scrollTabs = (direction = "next") => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "next" ? 300 : -300,
        behavior: "smooth",
      });
    }
  };

  return { scrollRef, scrollTabs };
}
